'use es6';

import http from 'hub-http-rxjs/clients/apiClient';
import hubHttp from 'hub-http/clients/apiClient';
import { map } from 'rxjs/operators/map';
import Activities from '../models/Activities';
import SmartContentActivities from '../models/SmartContentActivities';
const ACTIVIES_URI = 'activities/v2/reports/all-pages/total';
const SMART_CONTENT_URI = 'activities/v2/reports/targeted-content/total';
export default {
  fetchActivites(pageId) {
    const query = {
      f: pageId
    };
    return http.get(ACTIVIES_URI, {
      query
    }).pipe(map(Activities.fromJS));
  },
  fetchContentUrlForHubDBPage(analyticsPageId) {
    return hubHttp.get('activities/v2/reports/all-pages/metadata', {
      query: {
        f: analyticsPageId,
        useForeignIndex: true
      }
    }).then(({
      metadata
    }) => metadata[analyticsPageId] ? metadata[analyticsPageId].URL : '');
  },
  fetchSmartContentActivites(pageId) {
    const query = {
      pageId
    };
    return http.get(SMART_CONTENT_URI, {
      query
    }).pipe(map(SmartContentActivities.fromJS));
  }
};